import { useEffect, useRef, useState } from "react";
import React from 'react'; // Make sure React is imported
import Chart from "chart.js/auto";
import { TreemapController, TreemapElement } from "chartjs-chart-treemap";
import {
  ChoroplethController,
  GeoFeature,
  ColorScale,
  ProjectionScale,
  BubbleMapController,
  SizeScale,
} from "chartjs-chart-geo";

Chart.register(
  TreemapController,
  TreemapElement,
  ChoroplethController,
  GeoFeature,
  ColorScale,
  ProjectionScale,
  SizeScale,
  BubbleMapController
);
import * as ChartGeo from "chartjs-chart-geo";
import { zip } from "lodash";


let geoDataPromise: Promise<any> | null = null;


const getGeoData = () => {
  if (!geoDataPromise) {
    // console.log("Fetching US Atlas data for the first time...");
    geoDataPromise = fetch("https://unpkg.com/us-atlas/states-10m.json")
      .then((r) => r.json())
      .catch((err) => {
        geoDataPromise = null; // Reset so we can retry if it fails
        throw err;
      });
  }
  return geoDataPromise;
};
/**
 * Renders a chart bar component for Dashboard page with data.
 *
 * @param {object} props - The props object containing the data, name, type, height, width, and rest.
 * @param {any} props.data - The data for the chart.
 * @param {string} props.name - The name of the chart.
 * @param {string} props.type - The type of the chart.
 * @param {number} [props.height=300] - The height of the chart.
 * @param {number} [props.width=300] - The width of the chart.
 * @param {object} props.rest - The rest of the props.
 * @return {JSX.Element} The chart bar component.
 */
const ChartBar = ({
  data,
  name,
  type,
  height = 300,
  width = 300,
  className,
  options = {
    plugins: {
      legend: {
        position: "bottom",
      },
    },

  },
  ...rest
}: any) => {


  console.log('chart_re_render', type, data)
  const chartRef: any = useRef(null);
  // const [chartData, setChartData] = useState(null)
  // https://unpkg.com/us-atlas@3.0.1/states-10m.json


  // useEffect(() => {
  //   setChartData(chartData);
  // }, [data])


  // Global cache object to store the fetched geo data
  const geoDataCache: any = {
    data: null,
    promise: null,
  };

  const getUsAtlasData = async () => {
    // If we already have the data, return it
    if (geoDataCache.data) return geoDataCache.data;

    // If a request is already in progress, return that same promise
    if (geoDataCache.promise) return geoDataCache.promise;

    // Otherwise, start the fetch and store the promise
    geoDataCache.promise = fetch("https://unpkg.com/us-atlas/states-10m.json")
      .then((r) => r.json())
      .then((us) => {
        geoDataCache.data = us;
        return us;
      })
      .catch((err) => {
        geoDataCache.promise = null; // Reset promise on error so we can retry
        throw err;
      });

    return geoDataCache.promise;
  };



  useEffect(() => {

    console.log('cb data', data, type, name, options);
    if (!chartRef.current) return;


    const createChart = (canvas: any, chartData: any) => {
      if (canvas) {
        // if (canvas.chart) {
        //   canvas.chart.destroy();
        // }
        if (type === "choropleth") {

          getGeoData()
            .then((us: any) => {
              const nationGeoData: any = ChartGeo.topojson.feature(
                us,
                us.objects.nation
              );
              const statesGeoData: any = ChartGeo.topojson.feature(
                us,
                us.objects.states
              );
              const nation: any = nationGeoData?.features[0];
              const state: any = statesGeoData?.features;
              canvas.chart = new Chart(canvas.getContext("2d"), {
                type: type,
                data: {
                  labels: state.map((d: any) => d.properties.name),
                  datasets: [
                    {
                      label: "States",
                      outline: nation,
                      data: state.map((d: any) => ({
                        feature: d,
                        value:
                          // chartData.filter((value: any) => value.zipcode === d.properties.name)?.[0]?.total ?? 0,
                          chartData.filter((value: any) => value.zipcode === d.properties.name)
                            .reduce((sum: any, item: any) => sum + item.total, 0),
                      })),
                    },
                  ],
                },
                options: {
                  ...options, ...{
                    onHover: (e: any, elements: any, chart: any) => {
                      const canvas = chart.canvas;
                      if (elements.length > 0) {
                        canvas.style.cursor = 'pointer';
                      } else {
                        canvas.style.cursor = 'default';
                      }
                    },
                    plugins: {
                      tooltip: {
                        enabled: false, // Disable the default tooltip
                        external: function (context: any) {
                          let tooltipEl = document.getElementById('chartjs-tooltip');
                          if (!tooltipEl) {
                            tooltipEl = document.createElement('div');
                            tooltipEl.id = 'chartjs-tooltip';
                            document.body.appendChild(tooltipEl);
                          }

                          const tooltipModel = context.tooltip;
                          const chartCanvas = context.chart.canvas;




                          if (!chartCanvas.dataset.scrollListenerAttached) {
                            chartCanvas.addEventListener('wheel', (event: any) => {
                              const tooltipEl = document.getElementById('chartjs-tooltip');
                              if (tooltipEl && tooltipEl.style.opacity === '1') {
                                const zipContainer = tooltipEl.querySelector('#zip-container');
                                if (zipContainer) {
                                  // Prevent the main page from scrolling
                                  event.preventDefault();

                                  // Manually scroll the internal container
                                  // event.deltaY is positive when scrolling down, negative when up
                                  zipContainer.scrollTop += event.deltaY;
                                }
                              }
                            }, { passive: false }); // 'passive: false' is required to use preventDefault()

                            chartCanvas.dataset.scrollListenerAttached = 'true';
                          }




                          // console.log('tooltipEl', tooltipEl, tooltipEl.matches(':hover'))
                          // const isHoveringCanvas = chartCanvas?.matches(':hover') || 1;
                          // const isHoveringTooltip = tooltipEl?.matches(':hover') || 1;

                          if (tooltipModel.opacity === 0) {
                            // if (!isHoveringTooltip) {
                            tooltipEl.style.opacity = '0';
                            // tooltipEl.style.pointerEvents = 'none';
                            tooltipEl.style.left = '-9999px';
                            // }
                            return;
                          }


                          if (!chartCanvas.dataset.listenerAttached) {
                            chartCanvas.addEventListener('mouseleave', () => {
                              const tooltipEl = document.getElementById('chartjs-tooltip');
                              if (tooltipEl && tooltipModel.opacity === 0) {

                                // Wait a split second to see if mouse moved INTO the tooltip
                                setTimeout(() => {
                                  // if (!tooltipEl.matches(':hover')) {
                                  tooltipEl.style.opacity = '0';
                                  // tooltipEl.style.pointerEvents = 'none';
                                  tooltipEl.style.left = '-9999px';
                                  // }
                                }, 100);
                              }
                            });
                            chartCanvas.dataset.listenerAttached = 'true';
                          }




                          // if (tooltipModel.opacity === 0) {
                          //   tooltipEl.style.opacity = '0';
                          //   return;
                          // }

                          if (tooltipModel.body) {
                            const dataIndex = tooltipModel.dataPoints[0].dataIndex;
                            const dataset = tooltipModel.dataPoints[0].dataset;
                            const stateName = dataset.data[dataIndex]?.feature.properties.name || 'Unknown';
                            const totalUsers = dataset.data[dataIndex]?.value || 0;
                            const zipData = chartData.filter((val: any) => val.zipcode === stateName);

                            // Render HTML
                            let innerHtml = `
                                        <div class="tooltip-header">${stateName}</div>
                                        <div class="tooltip-body">
                                            <div class="tooltip-total"><span class="dot"></span><strong>Total Users:&nbsp;</strong>${totalUsers}</div>
                                            <hr />
                                            <div id="zip-container" class="zip-list">
                                    `;

                            zipData.forEach((item: any) => {
                              if (item.state) {
                                innerHtml += `
                                        <div class="zip-item">
                                            <span class="zip-code" style="font-weight:600;">${item.state}</span>
                                            <span class="zip-value"> ${item.total}</span>
                                        </div>`;
                              }
                            });
                            innerHtml += `</div></div>`;
                            tooltipEl.innerHTML = innerHtml;
                          }

                          // --- SMART HEIGHT & COLLUMN LOGIC ---
                          const chartHeight = context.chart.height;
                          // const tooltipHeight = tooltipEl.offsetHeight;
                          const zipContainer: any = tooltipEl.querySelector('#zip-container');

                          const rect = chartCanvas.getBoundingClientRect();
                          const activeElements = context.chart.getActiveElements();

                          let targetX = tooltipModel.caretX;
                          let targetY = tooltipModel.caretY;

                          // Use geometric center for maps if available
                          if (activeElements.length > 0) {
                            const element = activeElements[0].element;
                            const center = element.getCenterPoint();
                            targetX = center.x;
                            targetY = center.y;
                          }

                          // Initial desired position
                          let left = rect.left + targetX + 10;
                          let top = rect.top + targetY - 10;

                          const tooltipWidth = tooltipEl.offsetWidth;
                          const tooltipHeight = tooltipEl.offsetHeight;

                          // Boundary Constants (Canvas edges)
                          const canvasRight = rect.left + chartCanvas.offsetWidth;
                          const canvasBottom = rect.top + chartCanvas.offsetHeight;

                          // A. Stay inside Canvas Right: If it overflows, flip to the left of the cursor
                          if (left + tooltipWidth > canvasRight) {
                            left = rect.left + targetX - tooltipWidth - 20;
                          }

                          // B. Stay inside Canvas Bottom: Push up if it hits the bottom
                          if (top + tooltipHeight > canvasBottom) {
                            top = canvasBottom - tooltipHeight - 5;
                          }

                          // C. Safety check: Don't go past Canvas Left/Top
                          left = Math.max(rect.left + 5, left);
                          top = Math.max(rect.top + 5, top);
                          tooltipEl.style.opacity = '1';
                          // tooltipEl.style.pointerEvents = 'auto';
                          tooltipEl.style.left = Math.max(0, left) + 'px';
                          tooltipEl.style.top = Math.max(0, top) + 'px';
                        }
                      },
                      legend: {
                        display: false,
                      },
                    },
                    scales: {
                      projection: {
                        axis: "x",
                        projection: "albersUsa",
                      },
                      color: {
                        axis: "x",
                        // quantize: 5,
                        legend: {
                          position: "bottom-right",
                          align: "bottom",
                        },
                      },
                    },
                  },
                }
              });
            })
            .catch((error: any) => {
              error;
            });
        }
        else if (type === "bubbleMap") {
          getGeoData()
            .then((us: any) => {
              const nationGeoData: any = ChartGeo.topojson.feature(us, us.objects.nation);
              const statesGeoData: any = ChartGeo.topojson.feature(us, us.objects.states);

              const nation: any = nationGeoData?.features[0];
              const states: any = statesGeoData?.features;

              canvas.chart = new Chart(canvas.getContext("2d"), {
                type: type, // Changed from choropleth
                data: {
                  labels: chartData.map((d: any) => d.zipcode),
                  // labels: states.map((d: any) => d.properties.name),
                  datasets: [{
                    label: "States",
                    outline: states,
                    showOutline: true,
                    backgroundColor: "rgba(54, 162, 235, 0.5)", // Bubble color
                    data: chartData.map((d: any) => {
                      return {
                        zipcode: d.zipcode,
                        feature: d,
                        latitude: d.lattitude,
                        longitude: d.longitude,
                        value: d.total ?? 0,
                      };
                    }),

                  }],
                },
                options: {
                  ...options,
                  scales: {
                    projection: {
                      axis: "x",
                      projection: "albersUsa",
                    },
                    size: { // Essential for BubbleMap size scaling
                      axis: "x",
                      size: [1, 25], // Min bubble size 1px, Max 25px
                    },
                  },
                  plugins: {
                    // tooltip: {
                    // callbacks: {
                    //   title: (context: any) => {
                    //     const dataIndex = context[0].dataIndex;
                    //     const stateName =
                    //       context[0].dataset.data[dataIndex]?.feature
                    //         .properties.name;
                    //     return ` ${stateName}`;
                    //   },
                    //   label: (context: any) => {
                    //     const dataIndex = context.dataIndex;
                    //     const value = context.dataset.data[dataIndex]?.value;
                    //     return `Number of users: ${value}`;
                    //   },
                    // },
                    // },
                    legend: {
                      display: false,
                    },
                  },
                  // ... rest of your plugins and tooltips
                }
              });
            });
        }
        else if (name === "Ethnicities") {
          canvas.chart = new Chart(canvas, {
            type: type,
            data: chartData,
            options: {
              ...options
              , ...{
                onHover: (e: any, elements: any, chart: any) => {
                  const canvas = chart.canvas;
                  if (elements.length > 0) {
                    canvas.style.cursor = 'pointer';
                  } else {
                    canvas.style.cursor = 'default';
                  }
                },
                plugins: {
                  tooltip: {
                    callbacks: {
                      title: (context: any) => {
                        const dataIndex = context[0].dataIndex;
                        const groupLabel =
                          context[0].dataset.tree[dataIndex]?.category;
                        return ` ${groupLabel}`;
                      },
                      label: (context: any) => {
                        const dataItem = context.dataset.data[context.dataIndex];
                        return `Total: ${dataItem.v}`;
                      },
                    },
                  },
                  legend: {
                    display: false,
                  },
                },
              }
            },
          });
        } else {
          canvas.chart = new Chart(canvas, {
            type: type,
            data: chartData,

            options: {
              ...options, ...{
                onHover: (e: any, elements: any, chart: any) => {
                  const canvas = chart.canvas;
                  if (elements.length > 0) {
                    canvas.style.cursor = 'pointer';
                  } else {
                    canvas.style.cursor = 'default';
                  }
                },
              }
            },
          });
        }
      }
    };
    createChart(chartRef.current, data);

    console.log('graph rerender', data, type)
    return () => {
      if (chartRef.current) {
        chartRef.current.chart?.destroy();
      }
    };
  }, [data, type]);  // }, []);








  const convertChartDataToCSV = (args: any) => {
    let result, columnDelimiter, lineDelimiter, labels, data;

    data = args.data.data || null;
    if (data == null || !data.length) {
      return null;
    }

    labels = args.labels.map((item: any) => item.replaceAll(',', '')) || null;
    if (labels == null || !labels.length) {
      return null;
    }

    columnDelimiter = args.columnDelimiter || ',';
    lineDelimiter = args.lineDelimiter || '\n';

    result = '' + columnDelimiter;
    result += labels.join(columnDelimiter);
    result += lineDelimiter;

    result += args.data.label.toString();

    for (let i = 0; i < data.length; i++) {
      result += columnDelimiter;
      result += data[i];
    }
    result += lineDelimiter;

    return result;
  }

  const downloadCSV = () => {
    // console.log(chartRef.current.chart.config.data.labels,'-',chartRef.current.chart.data.datasets)
    var data, filename, link, chart;
    chart = chartRef.current.chart;
    var csv = "";
    for (var i = 0; i < chart.data.datasets.length; i++) {
      csv += convertChartDataToCSV({
        data: chart.data.datasets[i],
        labels: chart.config.data.labels
      });
    }
    if (csv == null) return;
    // console.log(csv);

    filename = 'chart-data.csv';
    if (!csv.match(/^data:text\/csv/i)) {
      csv = 'data:text/csv;charset=utf-8,' + csv;
    }

    // not sure if anything below this comment works
    data = encodeURI(csv);
    link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    document.body.appendChild(link); // Required for FF
    link.click();
    document.body.removeChild(link);
  }




  return (
    <>
      <canvas ref={chartRef} width={width} height={height} className={className} {...rest} style={{ width: '25rem !important', height: '25rem !important' }}></canvas>
      {/* {data && Object.keys(data).length} */}
      {/* <button onClick={()=>downloadCSV()}>Donwlod Csv</button> */}
    </>
    //
  );


};


function shallowEqualObjects(a: any, b: any) {
  if (a === b) return true;
  try { return JSON.stringify(a) === JSON.stringify(b); }
  catch (e) { return false; }
}

export default React.memo(ChartBar, (prevProps, nextProps) => {
  return (
    // prevProps.type === nextProps.type &&
    prevProps.type === nextProps.type &&
    prevProps.name === nextProps.name &&
    prevProps.height === nextProps.height &&
    prevProps.width === nextProps.width &&
    shallowEqualObjects(prevProps.data, nextProps.data) &&
    shallowEqualObjects(prevProps.options, nextProps.options)
  );
});
// export default ChartBar;
